import {
    rsaDecryptWithPrivateKey,
    rsaEncryptWithPublicKey,
    rsaSignWithPrivateKey,
    rsaVerifyWithPublicKey
} from "./RsaHelper";
import {aesDecrypt, aesEncrypt, genRandomHexStr} from "./AesHelper";

export function getDecodeInputStream(request, bodyEncrypt = false) {
    let encryptionKey = '';
    let encryptionData = '';
    if (bodyEncrypt) {
        const decryptKey = rsaDecryptWithPrivateKey(request.encryptionKey)
        const decryptData = aesDecrypt(request.encryptionData, decryptKey)
        const decryptBody = JSON.parse(decryptData)
        encryptionKey = decryptBody.sign
        encryptionData = decryptBody.data
    } else {
        encryptionKey = request.encryptionKey
        encryptionData = request.encryptionData
    }
    if (!rsaVerifyWithPublicKey(encryptionData, encryptionKey)) {
        return ""
    }
    return encryptionData
}

export function getEncodeData(data, bodyEncrypt = false) {
    data = JSON.stringify(data)
    const sign = rsaSignWithPrivateKey(data)
    let encryptionKey = '';
    let encryptionData = '';
    if (bodyEncrypt) {
        const aesKey = genRandomHexStr(16)
        const encryptionBody = {"sign": sign, "data": data}
        const encryptionBodyStr = JSON.stringify(encryptionBody)
        encryptionData = aesEncrypt(encryptionBodyStr, aesKey)
        encryptionKey = rsaEncryptWithPublicKey(aesKey)
    } else {
        encryptionData = data
        encryptionKey = sign
    }
    return {"encryptionKey": encryptionKey, "encryptionData": encryptionData}
}



// WEBPACK FOOTER //
// ./src/security/EncryptionUtil.js